export const i18nPluginDeps = ["i18n:plugin"]